"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveTokensToPayloadObj = exports.saveIdsToPayloadObj = void 0;
const storeFbIds_1 = require("./storeFbIds");
const storeGaIds_1 = require("./storeGaIds");
const storeSegmentId_1 = require("./storeSegmentId");
/**
 * Saves the IDs to the ldPayload object. Invokes separate methods
 * depending on the trackers present on the page and the tracking IDs
 * given in the arguments object.
 * @param {IFetcherFunction} object GA3 and GA4, FB and Segment tracking IDs
 * @param {ILDTransactionMonitorPayload} ldPayload ldPayload object
 * @returns {Promise<void>} promise resolved response for each of the trackers saved to LD localStorage
 */
const saveIdsToPayloadObj = async ({ ga3PropertyId, ga4MeasurementId, fbPixelId, segmentWriteKey, }, ldPayload) => {
    const gaId = ga4MeasurementId || ga3PropertyId;
    if (fbPixelId)
        (0, storeFbIds_1.storeFbIds)(ldPayload);
    if (gaId) {
        await (0, storeGaIds_1.storeGaIds)(gaId, "client_id", ldPayload);
    }
    if (ga4MeasurementId)
        await (0, storeGaIds_1.storeGaIds)(ga4MeasurementId, "session_id", ldPayload);
    if (segmentWriteKey)
        await (0, storeSegmentId_1.storeSegmentId)(ldPayload);
};
exports.saveIdsToPayloadObj = saveIdsToPayloadObj;
/**
 * Saves the Shopify tokens to the ldPayload object.
 * @param {ILDTransactionMonitorPayload} ldPayload - ldPayload object
 * @param {ISenderFunction} shopifyCartToken - Shopify Cart token
 * @param {ISenderFunction} shopifyCheckoutToken - Shopify Checkout token
 * @returns {ILDTransactionMonitorPayload | undefined} saves one or the other token to the ldPayload object
 */
const saveTokensToPayloadObj = (ldPayload, shopifyCartToken, shopifyCheckoutToken) => {
    if (shopifyCartToken && typeof shopifyCartToken === "string")
        return (ldPayload.cartID = shopifyCartToken);
    if (shopifyCheckoutToken && typeof shopifyCheckoutToken === "string")
        return (ldPayload.checkoutID = shopifyCheckoutToken);
};
exports.saveTokensToPayloadObj = saveTokensToPayloadObj;
